import { getUserNameFromSessionStorage } from '../services/session-storage-service';

/**
 * Emails allowed to see the redesigned device-detail ("Detailed") dashboard
 * view while that feature is in limited release. Compared case-insensitively.
 * The logged-in identifier is the Cognito username, which is the user's email
 * (see auth.context loginToApplication).
 */
const DEVICE_MONITOR_ALLOWLIST = ['suresh@potsdamsensors.com'];

/**
 * Whether the current user may see the redesigned "Detailed" dashboard view.
 * The "Map" view is generally available and is not gated by this check.
 * @returns True if the logged-in user's email is on the allowlist.
 */
export default function canUseDeviceMonitorViews(): boolean {
  const email = getUserNameFromSessionStorage().trim().toLowerCase();
  return DEVICE_MONITOR_ALLOWLIST.includes(email);
}

/**
 * Whether the current user may see the OPC-N3 bin analysis page.
 *
 * Generally available since 2026-09-24; the page shows an empty state for
 * devices without an OPC-N3 sensor, so there is nothing to gate.
 * @returns Always true.
 */
export function canUseOpcBinAnalysis(): boolean {
  return true;
}

/**
 * Whether the current user may see the APS channel analysis page.
 *
 * Generally available since 2026-09-24, alongside the OPC-N3 page.
 * @returns Always true.
 */
export function canUseApsChannelAnalysis(): boolean {
  return true;
}
